import { render } from "./Ceo.vue?vue&type=template&id=b215cc52&scoped=true"
import script from "./Ceo.vue?vue&type=script&lang=js"
export * from "./Ceo.vue?vue&type=script&lang=js"

import "./Ceo.vue?vue&type=style&index=0&id=b215cc52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b215cc52"

export default script